import { cn } from '@utils/cn';
import { DashboardItemProps } from './types';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { DashboardItemActionButton } from './button';
import { useDashboardItems } from '@hooks/dashboard/items';
import { useElementMeasures } from '@hooks/useElementMeasures';
import { useAppScrollTop } from '@hooks/appScroll';
import { getElementStyle } from '@utils/getElementStyle';

export const DashboardItem = ({
  id,
  title,
  actions,
  body,
  children,
  aside,
  disabled,
}: DashboardItemProps) => {
  const { toggle, isOpen } = useDashboardItems();
  const headerHeight = useElementMeasures('header').height;
  const stickyHeaderHeight = useElementMeasures('dashboard-sticky-header').height;
  const gap = getElementStyle('dashboard-layout', 'gap');
  const scrollTop = useAppScrollTop();

  return (
    <>
      <header
        id={`dashboard-item-${id}`}
        onClick={() => {
          if (disabled) return;
          toggle(id);
        }}
        style={{
          top: headerHeight + stickyHeaderHeight + gap - scrollTop,
        }}
        className={cn([
          'col-start-1 col-end-5 mt-2 flex cursor-pointer select-none justify-between overflow-hidden border-neutral-200 bg-white first-of-type:mt-0',
          isOpen(id) ? 'rounded-t-lg border-b-2' : 'rounded-lg',
          disabled && 'cursor-default bg-neutral-50 line-through',
        ])}>
        <div className="flex min-w-0 items-center gap-2.5 px-6 max-[899px]:px-3 max-[899px]:py-2">
          {typeof title === 'string' ? (
            <h2 className="text-lg font-bold text-neutral-800">{title}</h2>
          ) : (
            title
          )}
        </div>
        <div className="flex">
          <div className="flex items-center gap-4 px-6 py-4 max-[899px]:gap-0 max-[899px]:px-1 max-[899px]:py-1">
            {!disabled && actions}
            <DashboardItemActionButton
              className="h-7 max-[899px]:h-11 max-[899px]:w-11 max-[899px]:justify-center"
              disabled={disabled}
              onClick={() => toggle(id)}>
              <SvgConsumer
                id="expand"
                className={cn('shrink-0 text-sm', !isOpen(id) && 'rotate-180')}
              />
            </DashboardItemActionButton>
          </div>
          {aside}
        </div>
      </header>
      {isOpen(id) && (
        <>
          {body}
          {children}
        </>
      )}
    </>
  );
};
